import React, { useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { HomeOurProductItemMolecule } from '../../molecules/home-our-product-item/home-our-product-item.molecule';
import { slickOurProductDetails } from '../../../enums/homepage/our-products';

export const HomeOurProductsOrganism = () => {
  const [lensOpened, openLens] = useState(false);
  const [dropsOpened, openDrops] = useState(false);
  const [blgOpened, openBlg] = useState(false);

  function toggleLens() {
    openLens(!lensOpened);
  }
  function toggleDrops() {
    openDrops(!dropsOpened);
  }
  function toggleBlg() {
    openBlg(!blgOpened);
  }

  return (
    <section
      className="block bg-waldo-blue mt-5 lg:mt-8 py-6 lg:py-12 relative"
      id="OurProducts"
    >
      <div className="w-11/12 lg:w-4/5 mx-auto focus:outline-none">
        <div className="block w-full  focus:outline-none">
          <h2 className="text-white text-center text-large">Our products</h2>
          <p className="text-white mt-3 text-center block w-9/10 mx-auto text-regular">
            Browse our full range of ultra-hydrating, high quality and
            affordable products.
          </p>
        </div>

        <div className="w-full box-border block relative z-10 focus:outline-none mt-10">
          <HomeOurProductItemMolecule
            ourProductsDetails={slickOurProductDetails.LENSES}
            toggleFunc={toggleLens}
            funcOpened={lensOpened}
          />
          <HomeOurProductItemMolecule
            ourProductsDetails={slickOurProductDetails.DROPS}
            toggleFunc={toggleDrops}
            funcOpened={dropsOpened}
          />
          <HomeOurProductItemMolecule
            ourProductsDetails={slickOurProductDetails.BLG}
            toggleFunc={toggleBlg}
            funcOpened={blgOpened}
          />
        </div>
      </div>
    </section>
  );
};
